import React from 'react';

const GIF_URL =
  'https://cdn.shopify.com/s/files/1/0817/7844/2548/files/Pawnec_Loading_GIF_Transparent.gif?v=1769149995';

const SIZES = {
  xs: 'w-8 h-8',
  sm: 'w-12 h-12',
  md: 'w-20 h-20',
  lg: 'w-28 h-28',
};

/**
 * Shared loading indicator that uses the Pawnec animated GIF.
 *
 * Props:
 *  size     — 'xs' | 'sm' | 'md' | 'lg'  (default 'md')
 *  label    — optional text shown below the GIF
 *  fullPage — when true, centres itself in the viewport
 *  className — extra classes applied to the inner wrapper
 */
const PawLoader = ({ size = 'md', label = null, fullPage = false, className = '' }) => {
  const inner = (
    <div className={`flex flex-col items-center justify-center gap-2 ${className}`}>
      <img src={GIF_URL} alt="Loading…" className={SIZES[size]} style={{ objectFit: 'contain' }} />
      {label && <p className="text-sm text-gray-500">{label}</p>}
    </div>
  );

  if (fullPage) {
    // Pinned to the viewport rather than laid out in the document flow: a min-height
    // block only centres against its own box, so inside a scrolled or header-offset
    // container the GIF lands below the fold instead of in the middle of the screen.
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
        {inner}
      </div>
    );
  }

  return inner;
};

export default PawLoader;
